import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useDispatch, useSelector } from "react-redux";
import commentary from "../../assets/images/commentary.png";
import { useAppSelector } from "../../store/hooks";
import MatchCard from "../common/MatchCard";
import cricket from "../../assets/images/menu-4.png";
import football from "../../assets/images/menu-1.png";
import tennis from "../../assets/images/menu-2.png";
import casino from "../../assets/images/menu-99998.png";
import { fetchHomeAllMatches } from "../../store/slices/matchesSlice";
import { sportWiseMatchesFecthInterval } from "../../env";

import {
  BANNER_SLIDES,
  BANNER_SLIDES_QT,
  CASINO_PROVIDER_IMAGES,
  CASINO_PROVIDER_IMAGES_QT,
  THUMB_IMAGES,
  THUMB_IMAGES_QT,
} from "../../constants/casinoProviderImages";
import {
  navigateToCasinoGameLaunch,
  thumbItemHasPath,
} from "../../utils/casinoLaunchNavigation";
import { Modal } from "react-bootstrap";

const CRICKET_EVENT_TYPE_ID = 4;
const FOOTBALL_EVENT_TYPE_ID = 1;
const TENNIS_EVENT_TYPE_ID = 2;
const MAX_MATCHES_HOME = 50;

const filterLive = (matches) =>
  (matches || []).filter((m) => m.in_play === 1).slice(0, MAX_MATCHES_HOME);

const Inplay = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth || {});
  const { matchesBySport } = useSelector((state) => state.matches);
  const { news } = useSelector((state) => state.news);

  const cricketAll = matchesBySport[String(CRICKET_EVENT_TYPE_ID)] || [];
  const footballAll = matchesBySport[String(FOOTBALL_EVENT_TYPE_ID)] || [];
  const tennisAll = matchesBySport[String(TENNIS_EVENT_TYPE_ID)] || [];

  const newsHeadingsText = useMemo(() => {
    const payload = news;
    const items = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.data)
        ? payload.data
        : [];

    return items
      .map((x) => x?.heading)
      .filter(Boolean)
      .join("  •  ");
  }, [news]);

  // Short-pool home matches every 3 seconds while on /inplay
  useEffect(() => {
    // Initial fetch
    dispatch(fetchHomeAllMatches()).catch(() => {});

    const intervalId = setInterval(() => {
      dispatch(fetchHomeAllMatches()).catch(() => {});
    }, sportWiseMatchesFecthInterval);

    return () => clearInterval(intervalId);
  }, [dispatch]);

  const cricketMatches = useMemo(() => filterLive(cricketAll), [cricketAll]);
  const footballMatches = useMemo(() => filterLive(footballAll), [footballAll]);
  const tennisMatches = useMemo(() => filterLive(tennisAll), [tennisAll]);

  

  const handleGameClick = useCallback(
    (game) => {
      navigateToCasinoGameLaunch(navigate, game, {}, auth);
    },
    [navigate, auth],
  );

  const activeSport = useSelector((state) => state?.sidebar?.sportsInfo);

  const isSportAvailable = (id) => {
    return activeSport?.some((sport) => sport.sport_id === id);
  };

  return (
    <section className="section listing_page">
      
      <div className="row">
        <div className="col-12 d-flex">
          <div className="commentary">
            <img src={commentary} alt="commentary" />
            <div className="commentary-ticker" aria-live="polite">
              <span>{newsHeadingsText || "Welcome..."}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12 listing_page_12">
        <div className="middle-page-content home-page">
          <div className="game-slider mb-2">
            <div className="coupon-card">
              <div className="custom-thumb-section">
                {(isSportAvailable("QT") ? THUMB_IMAGES_QT : THUMB_IMAGES).map(
                  (item, index) => (
                    <div
                      key={item.path || item.game_id || item.game_code || index}
                      className={`cts-img popularDiv${item.hcDiv ? " hc_div" : ""}`}
                    >
                      {thumbItemHasPath(item) ? (
                        <Link to={item.path}>
                          <img
                            className="img-fluid"
                            src={item.src}
                            alt={item.game_name || ""}
                          />
                        </Link>
                      ) : (
                        <div
                          role="button"
                          tabIndex={0}
                          onClick={() => handleGameClick(item)}
                          onKeyDown={(e) =>
                            e.key === "Enter" && handleGameClick(item)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            className="img-fluid"
                            src={item.src}
                            alt={item.game_name || ""}
                          />
                        </div>
                      )}
                    </div>
                  ),
                )}
              </div>
              <div className="col-12 px-0 d-block d-md-none">
                <h2 className="ipl">new launch</h2>
              </div>
              <div className="top-baner mySwiper d-block d-md-none">
                <Swiper
                  modules={[Pagination]}
                  className="slider_banner"
                  spaceBetween={2}
                  slidesPerView={3}
                  loop
                  pagination={{ clickable: true }}
                  breakpoints={{
                    320: { slidesPerView: 3 },
                    576: { slidesPerView: 4 },
                  }}
                >
                  {(isSportAvailable("QT")
                    ? BANNER_SLIDES_QT
                    : BANNER_SLIDES
                  ).map((game, index) => (
                    <SwiperSlide
                      key={game.gameId ?? index}
                      className="slider_banner__item"
                    >
                      <div
                        role="button"
                        tabIndex={0}
                        onClick={() => handleGameClick(game)}
                        onKeyDown={(e) =>
                          e.key === "Enter" && handleGameClick(game)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          alt={game.alt || game.gameName || ""}
                          className="img-fluid slider_banner__item_img"
                          src={game.src}
                          style={{ width: "100%", height: "164px" }}
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              <div className="card">
                {cricketMatches?.length > 0 && (
                  <div className="card-body card-content p-0">
                    <MatchCard
                      sportTitle="Cricket"
                      matches={cricketMatches}
                      sportIcon={cricket}
                      instanceId="today"
                    />
                  </div>
                )}
                {footballMatches?.lenght > 0 && (
                  <div className="card-body card-content p-0">
                    <MatchCard
                      sportTitle="Football"
                      matches={footballMatches}
                      sportIcon={football}
                      instanceId="today"
                    />
                  </div>
                )}
                {tennisMatches?.length > 0 && (
                  <div className="card-body card-content p-0">
                    <MatchCard
                      sportTitle="Tennis"
                      matches={tennisMatches}
                      sportIcon={tennis}
                      instanceId="today"
                    />
                  </div>
                )}
              </div>
            </div>
            <span className="list-sport-title">
              <img
                src={casino}
                className="img-fluid game-icon-img"
                alt="casino"
              />{" "}
              Casino Provider
            </span>
            <div className="casinoprovider-thumb-section">
              {(isSportAvailable("QT")
                ? CASINO_PROVIDER_IMAGES_QT
                : CASINO_PROVIDER_IMAGES
              ).map((item, index) => (
                <div key={index} className="cts-img popularDiv">
                  <Link to={item.path || "/casino"}>
                    <img className="img-fluid" alt="" src={item.src} />
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Inplay;
